import { ConceptNodeMap } from "../../Concepts.interface";

export const getAllDescendants = (
  id: string,
  treeMap: ConceptNodeMap,
): string[] => {
  const node = treeMap[id];
  if (!node) return [];

  const children = node.children.map((child) => child.id);
  const grandChildren = node.children.flatMap((child) =>
    getAllDescendants(child.id, treeMap),
  );

  return [...children, ...grandChildren];
};
